import React from 'react';
import MenuRight from './MenuRight';
import MenuBottom from './MenuBottom.js';
import CenterButtons from './CenterButtons.js';
import Diamond from './images/Diamond.png';
import ActivityImg from './images/LevelingGround.png';
import Tooltip from './Tooltip';

function Leveling({ changeActiveComponent }) {
  const changeComponent = (id) => {
    if (id === 'assign') {
      changeActiveComponent('levelingassign');
    } else if (id === 'assigned') {
      changeActiveComponent('levelingunassign');
    }
  };

  return (
    <section id="leveling">
      <div className="platform-container">
        <div className="platform-activity-container">
          <div className="activity-container">
            <div className="activity-image-container"><img src={ActivityImg}/></div>
            <div className="activity-activity-container"><h2>LEVELING</h2><p>Level up your ants in the leveling ground. Your ant experience rate is based on it's level. Each level lowers required time to obtain one exp by 30 min.</p></div>
            <div className="activity-advantages-container"><h2>ADVANTAGE</h2><p>The Wise ANT levels up faster!</p></div>
            <CenterButtons changeComponent={changeComponent} /></div>
          </div>
      </div>
    </section>
  );
}

export default Leveling;